<script>
import {getAllDepartment} from "@/api/organize-api";
import {getAllArea} from "@/api/device-manager-api";
import {getApproveList} from '@/api/apply-api'
import {mixin_clearPhoneNumShow, mixin_page_table} from "@/utils/mixin";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {usual_visitor_sign_mixin} from "@/pages/helper/usual_visitor_mixin";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {getTodayApplyTotal} from "@/api/record-api";
import ApplyShowDetailDrawer from "@/components/ApplyShowDetailDrawer.vue";
import RecordShowDetailDrawer from "@/components/RecordShowDetailDrawer.vue";
import {getDataYMD} from "@/utils/commonUtils";
import {EventBus} from "@/main";

export default {
  name: "VisitorApplyPage",
  components: {RecordShowDetailDrawer, ApplyShowDetailDrawer, MyNotifyDialog, ClearPhoneNoDialog},
  mixins: [mixin_page_table, mixin_clearPhoneNumShow, usual_visitor_sign_mixin],

  data() {
    return {
      todayTotal: {
        bookNum: 0,
        inviteNum: 0,
      },

      selectTree: "",

      applyFormSearch: {
        employeeName: "",
        visitorName: "",
        dateArea: [],
        employeeWorkID: "",
        visitorPhoneNo: "",
        visitorCardNo: "",
        startTime: "",
        endTime: "",
        department: "", // 部门name
        selectDepartment: "",
        visitStatus: "",
      },
      searchParams: {},

      pickerOptions: {
        selectableRange: '00:00:00-23:59:59', // 设置可选的时间范围
        format: 'HH:mm' // 设置时间显示格式
      },
      defaultProps: {
        children: "departments",
        label: "name",
      },
      areaProps: {
        children: "areas",
        label: "name",
      },

      visitStatusApply: [
        {value: "ALL", label: "全部"},
        {value: "NO", label: "未到"},
        {value: "ENTER", label: "已到"},
      ],
      visitStatus: [
        {value: "ALL", label: "全部"},
        {value: "NO", label: "未到"},
        {value: "ENTER", label: "已到"},
        {value: "LEAVE", label: "离开"},
      ],

      departmentTreeData: [],
      areaTree: [],
      areaMap: {},

      tableColumnListTypeA: [
        {prop: "param1", label: "申请类型",width: 80,  type: 3},
        {prop: "employeeName", label: "员工姓名", width: 90, type: 0},
        {prop: "employeeDepartment", label: "员工部门", type: 0},
        {prop: "visitorName", label: "访客姓名", width: 90, type: 0},
        {prop: "visitorPhoneNo", label: "访客手机", width: 120, type: 9},
        {prop: "visitorCardNo", label: "访客卡号", type: 0},
        {prop: "showStartTime", label: "开始时间", width: 140, type: 0},
        {prop: "showEndTime", label: "结束时间", width: 140, type: 0},
        {prop: "areaName", label: "到访区域", type: 0},
        {prop: "state", label: "审核状态", width: 80, type: 2},
        // {prop: "arrived", label: "到访情况", width: 90, type: 2},
      ],

      notify: {
        title: "",
        show: false,
        success: false,
        msg: ""
      },


    }
  }, // end data

  mounted() {
    this.getTotalData()
    this.setupDepartmentData()
    this.setupAreaData()
    let nowDay = getDataYMD(new Date())
    this.applyFormSearch.dateArea = [nowDay, nowDay]

    this.onSearchClick()

  },

  methods: {
    getTotalData() {
      let areaIds = [this.$store.state.loginInfo.areaId]
      getTodayApplyTotal(areaIds).then(({data}) => {
        if (data.code === 200) {
          this.todayTotal.bookNum = data.data.bookNum
          this.todayTotal.inviteNum = data.data.inviteNum
        } else {
          console.log("getTodayRecordTotal err", data)
        }
      }).catch((err) => {
        console.error("getTodayRecordTotal err", err)
      })
    },
    setupDepartmentData() {
      getAllDepartment().then(({data}) => {
        if (data.code === 200) {
          this.departmentTreeData = data.data
          console.log("getAllDepartment", data);
        } else {
          this.showServerErrMsg(data.code)
        }
      }).catch(() => {
        this.showNetErrMsg()
      })
    },

    setupAreaData() {
      getAllArea().then(({data}) => {
        if (data.code === 200) {
          this.areaTree = data.data
          this.areaMap = {}
          this.areaTree.forEach(item => {
            this.areaMap[item.id] = item
            ;(item.areas || []).forEach(subItem => {
              this.areaMap[subItem.id] = subItem
            })
          })
        } else {
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log("doGetAllArea err", err)
        this.showNetErrMsg()
      })
    },

    onSearchClick() {
      this.refreshSearchParam()
      this.curPageIndex = 1
      this.refreshTableData()
    },

    getAllSelectDepartmentIds(selectDepartment, saveArr) {
      saveArr.push(selectDepartment.id)
      if (selectDepartment.departments && selectDepartment.departments.length > 0) {
        for (let i = 0; i < selectDepartment.departments.length; i++) {
          this.getAllSelectDepartmentIds(selectDepartment.departments[i], saveArr)
        }
      }
    },
    refreshSearchParam() {
      let params = {}
      if (this.applyFormSearch.employeeName) {
        params.employeeName = this.applyFormSearch.employeeName
      }
      if (this.applyFormSearch.visitorName) {
        params.visitorName = this.applyFormSearch.visitorName
      }
      if (this.applyFormSearch.dateArea && this.applyFormSearch.dateArea.length > 1) {
        params.beginDate = this.applyFormSearch.dateArea[0]
        params.endDate = this.applyFormSearch.dateArea[1]
      }
      if (this.applyFormSearch.employeeWorkId) {
        params.employeeWorkId = this.applyFormSearch.employeeWorkId
      }

      if (this.applyFormSearch.visitorPhoneNo) {
        params.visitorTel = this.applyFormSearch.visitorPhoneNo
      }
      if (this.applyFormSearch.visitorCardNo) {
        params.visitorCardNo = this.applyFormSearch.visitorCardNo
      }
      if (this.applyFormSearch.startTime || this.applyFormSearch.endTime) {
        params.beginTime = this.applyFormSearch.startTime ? this.applyFormSearch.startTime + ":00" : "00:00:00"
        params.endTime = this.applyFormSearch.endTime ? this.applyFormSearch.endTime + ":59" : "23:59:59"
      }

      if (this.applyFormSearch.department && this.applyFormSearch.selectDepartment) {
        params.departmentIds = []
        this.getAllSelectDepartmentIds(this.applyFormSearch.selectDepartment, params.departmentIds)
      }

      if (this.applyFormSearch.visitStatus && this.applyFormSearch.visitStatus !== "ALL") {
        params.arrived = this.applyFormSearch.visitStatus
      }

      params.entryAreaIds = [this.$store.state.loginInfo.areaId]
      this.searchParams = params
    },

    refreshTableData() {
      const pageData = {
        current: this.curPageIndex,
        size: this.curPageSize,
      }
      const searchParam = this.searchParams
      const postData = Object.assign(pageData, searchParam)
      getApproveList(postData).then(({data}) => {
        this.tableData = []
        if (data.code === 200 && data.data && data.data.data) {
          this.totalCount = data.data.totals
          data.data.data.forEach(item => {

            let areaName = ""
            if (item.entryArea) {
              let area = this.areaMap[item.entryArea]
              // let superArea = this.areaMap[area.parentId]
              // areaName = superArea && area ? superArea.name + "，" + area.name : ""
              areaName = area ? area.name : ""
            }

            let visitorTel = item.visitor.tel

            switch (item.type) {
              case "BOOK_APPLY":
              case "SCENE_APPLY":
                item.param1 = "预约"
                break
              case "INVITE_APPLY":
                item.param1 = "邀约"
                break
            }
            item.employeeName = item.employee ? item.employee?.name : ""
            item.employeeDepartment = item.employee ? item.employee.departmentName : ""
            item.visitorName = item.visitor.name
            item.visitorPhoneNo = visitorTel
            item.showStartTime = item.beginDate + " " + item.beginTime.substr(0, 5)
            item.showEndTime = item.endDate + " " + item.endTime.substr(0, 5)
            item.param14 = "查看"
            item.areaName = areaName
          })
          this.tableData = data.data.data
        }
      })
    },


    onResetSearch() {
      let nowDay = getDataYMD(new Date())
      this.applyFormSearch = {
        employeeName: "",
        visitorName: "",
        dateArea: [nowDay, nowDay],
        employeeWorkID: "",
        visitorPhoneNo: "",
        visitorCardNo: "",
        startTime: "",
        endTime: "",
        department: "", // 部门name
        visitStatus: "",
      }
      this.onSearchClick()
    },

    addAdminHandleNodeClick(data, node, item) {
      console.log("addAdminHandleNodeClick", data, node, item)
      this.applyFormSearch.department = data.name
      this.applyFormSearch.selectDepartment = data
      this.$refs.departmentSelect.blur()
    },

    areaNodeEnterClick(data, node, item) {
      console.log("areaNodeEnterClick", data, node, item)
      this.applyFormSearch.enterArea = data.name
      this.applyFormSearch.enterAreaId = data.id
    },

    areaNodeLeaveClick(data, node, item) {
      console.log("areaNodeLeaveClick", data, node, item)
      this.applyFormSearch.leaveArea = data.name
      this.applyFormSearch.leaveAreaId = data.id
    },


    tableShow1(rowData) {
      this.$refs.applyDetailDrawer.showApplyDetail(rowData)
    },


    onSignDialogClose() {
      this.notify.show = false
    },

    doSignEnter(apply) {
      // this.$router.push({name: "visitorRegister", params: {apply: apply}})
      EventBus.$emit('GuideJump', {index: "visitorRegister", name: "visitorRegister", params: {apply: apply}})
    },

    isValid(apply) {
      let now = new Date()
      // 比较日期 apply. beginDate <= now && now <= apply.endDate
      let beginDate = new Date(apply.beginDate + " 00:00:00")
      let endDate = new Date(apply.endDate + " 23:59:59")
      return now >= beginDate && now <= endDate;
    }
  },// end methods

  filters: {
    tableDateFilter(value, prop) {
      if (prop === "state") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "arrived") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else if (prop === "completeState") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else {
        return value
      }
    },
  }

}
</script>

<template>
  <div>
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="onSignDialogClose"></my-notify-dialog>

    <ApplyShowDetailDrawer drawer-title="详细信息" :areaMap="areaMap" ref="applyDetailDrawer" :phoneNumShow="phoneNumShow"/>
    <RecordShowDetailDrawer drawer-title="详细信息" :area-map="areaMap" ref="recordDetailDrawer" :phoneNumShow="phoneNumShow"></RecordShowDetailDrawer>

    <!-- top Area   -->
    <div class="total-radio w-full flex">
      <div class="w-1/2">
        <div class="text-center h-12 flex items-center justify-between bg-blue rounded-l-md border border-gray-400 text-2xl px-1.5">
          <div class="text-red-600 font-bold">今日数据</div>
          <div>
          <span class=" pr-1">邀约人数：</span>
          <span class="">{{ todayTotal.inviteNum }}</span>
          </div>
          <div></div>
        </div>
      </div>
      <div class="w-1/2 ">
        <div class="text-center h-12 flex items-center justify-center bg-blue rounded-r-md  border-gray-300">
          <div class="text-2xl pr-1">预约人数：</div>
          <div class=" text-2xl">{{ todayTotal.bookNum }}</div>
        </div>
      </div>
    </div>
    <!-- search Area-->
    <div class="pt-2 flex flex-row justify-start items-start border-t search-box">

      <el-form label-width="95px " :model="applyFormSearch" class="demo-form-inline" label-position="left">
        <el-form-item label="员工姓名">
          <el-input v-model="applyFormSearch.employeeName" :placeholder="`请输入员工姓名`"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="访客姓名">
          <el-input v-model="applyFormSearch.visitorName" placeholder="请输入访客姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
              class="my-date-picker"
              v-model="applyFormSearch.dateArea"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

      </el-form>

      <el-form label-width="95px " :model="applyFormSearch" class="demo-form-inline" label-position="left">
        <el-form-item label="员工工号">
          <el-input v-model="applyFormSearch.employeeWorkID" placeholder="请输入员工工号" clearable></el-input>
        </el-form-item>
        <el-form-item label="访客手机">
          <el-input v-model="applyFormSearch.visitorPhoneNo" placeholder="请输入访客手机" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-time-picker style="margin-right: 10px"
                          class="my-time-select"
                          placeholder="起始时间"
                          value-format="HH:mm"
                          format="HH:mm"
                          :picker-options="pickerOptions"
                          v-model="applyFormSearch.startTime">
          </el-time-picker>
          <el-time-picker
              class="my-time-select"
              placeholder="结束时间"
              v-model="applyFormSearch.endTime"
              value-format="HH:mm"
              format="HH:mm"
              :picker-options="pickerOptions">
          </el-time-picker>
        </el-form-item>

      </el-form>

      <el-form label-width="95px " :model="applyFormSearch" class="demo-form-inline" label-position="left">
        <el-form-item label="员工部门">
          <el-select ref="departmentSelect" v-model="applyFormSearch.department" :placeholder="`请选择部门`" value-key="id" clearable>
            <el-option :value="selectTree" class="setstyle" style="overflow: auto; height: 100%" disabled
                       :key="selectTree.id" :label="selectTree.name">
              <el-tree style="min-height: 150px; max-height: 300px" :data="departmentTreeData" :props="defaultProps"
                       ref="tree"
                       check-strictly :expand-on-click-node="false"
                       @node-click="(data, node, item) => addAdminHandleNodeClick(data, node, item)"></el-tree>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="到访情况">
          <el-select class="my-select" v-model="applyFormSearch.visitStatus" clearable>
            <el-option v-for="item in visitStatusApply" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div class="button-area">
            <span>
                 <el-button type="primary" @click="onSearchClick">查询</el-button>
                <el-button type="success" plain @click="onResetSearch">重置</el-button>
            </span>
          <span>
            <el-button type="danger" plain @click="cleartextShow('访客记录')">
              明文查看
            </el-button>
              </span>
        </div>
      </el-form>
    </div>


    <el-table :data="tableData" class="" key="tableColumnListTypeA" border stripe  headera>
      <el-table-column v-for="(headerItem) in tableColumnListTypeA" :key="headerItem.prop" :prop="headerItem.prop"
                       :label="headerItem.label" :width="headerItem.width" align="center" >
        <template v-slot="scope">
          <template v-if="headerItem.type === 0">{{ scope.row[headerItem.prop] }}</template>
          <template v-else-if="headerItem.type === 1">
            {{ scope.row[headerItem.prop] | tableDateFilter(headerItem.prop) }}
          </template>
          <el-tag v-else-if="headerItem.type === 2">{{
              scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
            }}
          </el-tag>
          <el-tag v-else-if="headerItem.type === 3">{{ scope.row[headerItem.prop] }}</el-tag>
          <template v-else-if="headerItem.type === 9">
            <template v-if="phoneNumShow">
              {{ scope.row[headerItem.prop] }}
            </template>
            <template v-else>
              {{ scope.row[headerItem.prop] | phNoFilter }}
            </template>
          </template>
          <template v-else-if="headerItem.type > 100">
            <el-button v-if="(headerItem.type % 100) & 1" type="primary"
                       @click="tableShow1(scope.row)">查看
            </el-button>
            <el-button v-if="(headerItem.type % 100) & 2" type="warning"
                       @click="tableEdit1(scope.row)">编辑
            </el-button>
            <el-button v-if="(headerItem.type % 100) & 4" type="danger"
                       @click="tableDelete1(scope.row)">删除
            </el-button>
          </template>
          <template v-else> {{ scope.row[headerItem.prop] }}</template>
        </template>
      </el-table-column>
      <el-table-column label="到访情况" width="80" align="center" >
        <template v-slot="scope">
          <template v-if="scope.row.arrived === 'NO'">
            <el-button size="small" v-if="isValid(scope.row) " type="primary" @click="doSignEnter(scope.row)">签到</el-button>
            <el-tag v-else>未到访</el-tag>
          </template>
          <el-tag v-else-if="scope.row.arrived === 'ENTER'">已到访</el-tag>
          <el-tag v-else-if="scope.row.arrived === 'LEAVE'">已离开</el-tag>
          <el-tag v-else>{{ scope.row.arrived }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center" >
        <template v-slot="scope">
          <el-button size="small" type="primary" @click="tableShow1(scope.row)">查看</el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="pager">
      <el-pagination layout="total, sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                     :page-size.sync="curPageSize" :pager-count="5"
                     :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>

  </div>
</template>

<style scoped lang="less">

.total-radio {

  /deep/ .el-radio-button__inner {
    width: 100%;
  }

  .first {
    /deep/ .el-radio-button__inner {
      border-radius: 8px 0 0 8px;
    }
  }

  .last {
    /deep/ .el-radio-button__inner {
      border-radius: 0 8px 8px 0;
    }
  }

  /deep/ .el-radio-button__inner {
    background-color: #f5f7fa;
  }

}

/deep/ .el-collapse-item__header {
  padding: 0;
  border-bottom: 1px solid #ebeef5;
  background-color: #f5f7fa;
}

/deep/ .el-collapse-item__wrap {
  background-color: #f5f7fa;
}

.my-date-picker /deep/ .el-range-separator {
  min-width: 22px;
}

.demo-form-inline {
  width: 33%;

  .el-input {
    width: calc(100% - 50px);
  }

  .el-select {
    width: calc(100%);
  }

  .my-date-picker {
    width: calc(100% - 50px);
  }

  .my-time-select {
    width: calc(50% - 30px);
  }

  .button-area {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding-right: 50px;

  }
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0;
}

.drawer-content {

  .drawer-title {
    margin-left: 10px;
    padding-left: 10px;
    padding-top: 10px;
  }

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 380px;
  }

  .grid-content {
    //padding: 20px;

    margin: 8px 8px 8px 20px;
  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
    //text-align: right;
    //margin-right: 8px;

  }

  .input-description-long {
    display: inline-block;
    width: 120px;
    //text-align: right;
    //margin-right: 8px;
  }
}

.image-header {
  width: 80px;
  height: 100px;
}

.image-photo {
  width: 360px;
  height: 270px;
  background-color: #efefef;
  line-height: 270px;
  text-align: center;
}


/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFF;
  //background-color: #ff0000;
  background-color: #409EFF;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409EFF;
}

.bg-blue {
  background: #409EFF
}

.search-box {
  /deep/ .el-form-item__label {
    font-size: 20px;
  }

  .el-input {
    font-size: 20px;
  }

  /deep/ .el-input__inner {
    font-size: 20px;

  }

  /deep/ .el-radio__label {
    font-size: 20px;
  }

  /deep/ .el-date-editor .el-range-input {
    font-size: 20px;
  }
}
</style>
